import {gql} from "apollo-angular";
import {baseResponse} from "../../../../store/base.graphql";
import {feedbackFields} from "../../../../store/entities/feedback/feedback.graphql";


export const RESEND_FORM_RESPONSE_RELAY_MUTATION = gql`
  mutation ResendFormResponseRelayMutation($responseUniqueId: String!) {
    resendFormResponseRelayMutation(responseUniqueId: $responseUniqueId) {
      data {
        id
        uniqueId
        responsePayload
      }
      response {
        id
        status
        code
        message
      }
    }
  }
`;

export const GET_SERVICE_FORM_RESPONSE_ATTACHMENTS = gql`
  query GetServiceFormResponseAttachments(
    $filtering: FormResponseAttachmentFilteringInputObject!
  ) {
    getServiceFormResponseAttachments(filtering: $filtering) {
      response {
        id
        status
        code
        message
      }
      data {
        id
        uniqueId
        name
        path
      }
    }
  }
`;

export const GET_SERVICE_FORM_RESPONSE_COMMENTS = gql`
  query GetServiceFormResponseComments(
    $filtering: FormResponseCommentFilteringInputObject!
  ) {
    getServiceFormResponseComments(filtering: $filtering) {
      response {
        id
        status
        code
        message
      }
      data {
        id
        uniqueId
        comment
        createdAt
        commentBy{
          profileUniqueId
          userLastName
        }
      }
    }
  }
`;
